import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/apps/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
